import { useLocalStorage } from "@uidotdev/usehooks";
import { useCallback } from "react";

const STORAGE_KEY = "firebase-token-v2";

export function useFirebaseSubscriptionStorage() {
  const [token, setToken] = useLocalStorage<string | null>(STORAGE_KEY, null);

  const save = useCallback(
    (token: string) => {
      setToken(token);
    },
    [setToken],
  );

  const remove = useCallback(() => {
    setToken(null);
  }, [setToken]);

  return {
    save,
    remove,
    token,
  };
}
